import { useSelector } from 'react-redux';
import { selectSelectedProductsByPassengerIndex } from 'selectors/productsCartSelectors';

/**
 * usePassengerHasProducts hook
 * Provides a boolean indicating if a specific passenger has products in the cart
 * Only checks the passenger at the provided index, ignoring other passengers
 *
 * @param {number} passengerIndex - Index of the passenger to check
 * @param {string} [segment='outgoing'] - Segment to check: 'outgoing' (default) or 'both'
 * @returns {boolean} True if the passenger has products in cart, false otherwise
 */
export const usePassengerHasProducts = (passengerIndex, segment = 'outgoing') => {
  const passengerProducts = useSelector(
    selectSelectedProductsByPassengerIndex(passengerIndex, 'outgoing'),
  );
  const passengerProductsIncoming = useSelector(
    selectSelectedProductsByPassengerIndex(passengerIndex, 'incoming'),
  );
  if (segment === 'both') {
    return passengerProducts.length > 0 || passengerProductsIncoming.length > 0;
  }

  return passengerProducts.length > 0;
};

export default usePassengerHasProducts;
